<style lang="stylus">
.nextButton {
  button {
    border-radius: 50px;
    background-color: #fec627 !important;
    font-size: 18px;
    height: 48px;
  }
}

.backButton {
  button {
    border-radius: 50px;
    font-size: 18px;
  }
}

.welcome-header {
  font-size: 48px;
  text-align: center;
  font-weight: 900;
}

.welcome-page-message {
  text-align: center;
  margin-top: 32px;
  font-weight: 400;
}

.welcome-header-mobile {
  font-size: 30px;
  text-align: center;
  font-weight: bold;
}

.register-button {
  text-align: center;
  margin-top: 66px;

  .v-btn {
    height: 53px;
    padding: 10px 32px;
    font-size: 18px;
  }
}

.exisiting-user-text {
  margin-top: 64px;
  text-align: center;
  font: Bold 36px / 43px Arial, Roboto;
  letter-spacing: -0.18px;
  color: #191919;
  opacity: 1;
}

.what-asurite-link {
  margin-top: 26px;
  font-size: 14px;

  a {
    text-decoration: underline;
    color: #8C1D40;
  }
}

.background-graduate-img {
  position: absolute;
  margin-bottom: -28px;
  // margin-top: 16%;
}

.login-button {
  text-align: center;

  .v-btn {
    font-size: 18px;
    height: 53px;
    margin-top: 71px;
    padding: 10px 64.124px;
  }
}

.asurite-id-mobile {
  display: inline-block;
  height: 34px;
  border-bottom: 6px solid #ffc627;
}

.new-user-register {
  height: 364px;
  background: #2A2A2A 0% 0% no-repeat padding-box;
  border-bottom: 3px solid #999;
  opacity: 1;
}

.exisiting-user-login {
  height: 364px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #D0D0D0;
  opacity: 1;
  border-bottom: 4px solid #FFC627;
}

.new-user-text {
  margin-top: 64px;
  text-align: center;
  font: Bold 36px / 43px Arial, Roboto;
  letter-spacing: -0.18px;
  color: #FFFFFF;
  opacity: 1;
}

@media (max-width: 1263px) {
  .background-graduate-img {
    display: none;
  }
}

// @media (min-width: 1904px) {
// .background-graduate-img {
// margin-top: 11%;
// }
// }

// @media (min-width: 1365px) and (max-width: 1366px) {
// .background-graduate-img {
// margin-top: 21.3%;
// }
// }
@media (min-width: 1023px) and (max-width: 1024px) {
  // .background-graduate-img {
  // margin-top: 30.8%;
  // }
  .register-footer-component {
    margin-top: 2%;
  }
}

@media (max-width: 768px) {
  // .background-graduate-img {
  // margin-top: 33.2%;
  // }
  .register-footer-component {
    margin-top: -24%;
  }
}

@media (max-width: 600px) {
  .register-footer-component {
    margin-top: -27%;
  }

  .new-user-register {
    height: 213px;
  }

  .new-user-text {
    height: 45px;
    margin-top: 30px;

    div {
      margin-top: -18px;
    }
  }

  .exisiting-user-text {
    height: 45px;
    margin-top: 30px;

    div {
      margin-top: -18px;
    }
  }

  .exisiting-user-login {
    height: 213px;
  }

  .new-user-text {
    font-size: 21px;
  }

  .exisiting-user-text {
    font-size: 16px;
  }

  .asurite-id-mobile {
    display: inline-block;
    height: 30px;
    border-bottom: 6px solid #ffc627;
    font-size: 21px;
  }

  .register-button {
    margin-top: 24px;

    .v-btn {
      margin: 0;
      height: 35px;
      font-size: 16px;
      padding: 0px 15.81px;
    }
  }

  .login-button {
    .v-btn {
      font-size: 16px;
      margin-top: 23px;
      height: 35px;
      padding: 0px 40.39px;
      margin-bottom: 0;
    }
  }

  .what-asurite-link {
    margin-top: 16px;
    font-size: 12px;
    text-align: center;

    a {
      text-decoration: underline;
      color: #8C1D40;
      width: 31px;
    }
  }

  .background-graduate-img {
    width: 172px;
    height: 217px;
    margin-top: 84.4%;
  }
}
</style>
<template>
  <div data-testid="welcome-desktop-page">
    <!-- Loading Overlay -->
    <v-overlay v-model="activeLoading" class="align-center justify-center" data-testid="loading-overlay">
      <v-progress-circular color="primary" indeterminate size="64" />
    </v-overlay>

    <v-row>
      <v-col cols="12" v-if="isPartnerDataLoaded">
        <create-learner-component-v2
          @setInitialForm="setInitialForm()"
          v-if="(isEligibleForSignUp || isAccelerate) && !error.message"
          data-testid="registration-section"
        />

        <welcome-login v-else-if="!error.message" data-testid="login-section" />

        <v-container class="containerFixedHeight d-flex align-center justify-center" v-else>
          <v-row align-center justify="center" wrap style="margin: 3rem auto 5rem auto; max-width: 600px">
            <v-col cols="12" style="max-width: 500px" class="auth-card">
              <error-component :message="error.message" :cta="error.cta" @clear="clear()" data-testid="error-section" />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';
import { useUiStore } from '@/stores/ui';
import { decodeState } from '../util/state-utils.js';
import { storeParamsFromUrl, storePendingParam, getPendingParam } from '../util/param-persistence.js';

import { FetchPartnerData } from '../mixins/fetchPartnerDataMixin';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { RedirectFlowMixin } from '../mixins/redirectFlowMixin';
import { Helper } from '../mixins/helpers.js';

export default defineComponent({
  name: 'WelcomeLoginComponent',

  data() {
    return {
      background: 'url(imageLocation) right / cover no-repeat',
      initialForm: true,
      error: {
        message: '',
        cta: ''
      },
      decodedStateData: null
    };
  },

  mixins: [FetchPartnerData, RedirectFlowMixin, AjaxLoader, Helper],

  computed: {
    header() {
      const userStore = useUserStore();
      return userStore.welcomePageData.welcomePageTitle;
    },
    isEligibleForSignUp() {
      const userStore = useUserStore();
      return userStore.welcomePageData.isEligibleForSignUp;
    },
    isPartnerDataLoaded() {
      const userStore = useUserStore();
      return userStore.welcomePageData.isEligibleForSignUp != undefined;
    },
    isAccelerate() {
      return this.isAcceleratePartner(this.$conn.getPartnerName());
    }
  },

  methods: {
    setInitialForm() {
      this.initialForm = false;
    },
    backButton() {
      this.initialForm = true;
    },
    clear() {
      this.error.message = '';
      this.$router.push('/');
    },
    /**
     * Captures UTM parameters from URL and stores session/referrer data
     * for analytics tracking during registration
     */
    captureUtmParams() {
      // Store UTM params and ad click IDs from URL
      storeParamsFromUrl(['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'gclid', 'fbclid']);

      // Generate session_id if not exists
      if (!getPendingParam('session_id')) {
        const sessionId = crypto.randomUUID();
        storePendingParam('session_id', sessionId);
      }

      // Capture landing_page if not exists
      if (!getPendingParam('landing_page')) {
        storePendingParam('landing_page', window.location.href);
      }

      // Capture referrer_url if not exists
      if (!getPendingParam('referrer_url') && document.referrer) {
        storePendingParam('referrer_url', document.referrer);
      }
    },
    /**
     * Saves encoded state data to localStorage for later retrieval after login
     */
    saveStateForLogin() {
      const encodedState = this.$route.query['state'];
      if (encodedState) {
        try {
          // Decode to validate the state and then store it
          this.decodedStateData = decodeState(encodedState);
          localStorage.setItem('login_state', encodedState);
          this.logInfo('State saved for login', this.decodedStateData);
        } catch (error) {
          this.logError('Failed to save state for login', error);
        }
      }
    }
  },

  async created() {
    if (this.$route.query && this.$route.query['verbose']) {
      let d = new Date();
      d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);

      document.cookie = 'verbose-logging=' + this.$route.query['verbose'] + ';expires=' + d.toUTCString();
      +';path=/;SameSite=Strict';
    }

    // Capture UTM parameters and session data for analytics tracking
    this.captureUtmParams();

    // Save state data if present
    this.saveStateForLogin();

    const userStore = useUserStore();
    if (userStore.welcomePageData.welcomePageTitle == undefined) {
      await this.fetchPartnerData({ course_offering_id: this.decodedStateData?.course_offering_id });
    }

    // Handle redirect from host mismatch
    if (this.hasRedirectSource()) {
      this.handleRedirectFlow();
    }

    // Check for global errors from UI store
    const uiStore = useUiStore();
    if (uiStore.globalError.message) {
      this.initialForm = false;
      this.error.message = uiStore.globalError.message;
      return;
    }

    if (this.$route.query && this.$route.query['asurite-sign-in'] === 'y') {
      this.$auth.login('asurite');
    }
  }
});
</script>
